var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{attrs:{"id":"echarts-trend-data"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{attrs:{"id":"trend_chart"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }